import { ANDROID_PACKAGE, APP_LINK, APP_ONE_LINK, DEEP_LINK } from '../enum/Constants';
import { parseQueryString } from '../util/common';
import { firebaseInit } from './firebase';
import '../../public/static/css/reset.css';
import '../../public/static/css/base.css';
import '../../public/static/css/common.css';
import '../../public/static/css/etc.css';
const goLink = (type, contentsId) => {
    const PID = parseQueryString().pid;
    const C = 'Aug2021';
    const baseLink = `${APP_ONE_LINK}?pid=${PID}&c=${C}&is_retargeting=true`;
    const infoLink = 'https://forms.gle/JmysajQUSsXWWo8k7';
    let link = '';
    if (type === 'join') {
        link = `${baseLink}&af_ios_url=${APP_LINK}/my&af_android_url=${DEEP_LINK}/mkmy`;
    }
    else if (type === 'contents') {
        link =
            `${baseLink}&af_ios_url=${APP_LINK}/video/${contentsId}?isDeep` +
                `&af_android_url=${DEEP_LINK}/?link=${APP_LINK}/video/${contentsId}?&apn=${ANDROID_PACKAGE}`;
    }
    else {
        link = infoLink;
    }
    window.open(link, '_self');
};
const initialize = () => {
    firebaseInit();
    const joinBtn = document.getElementById('join-button');
    const contentsBtn1 = document.getElementById('contents-button-1');
    const contentsBtn2 = document.getElementById('contents-button-2');
    const infoBtn = document.getElementById('info-button');
    if (joinBtn && contentsBtn1 && contentsBtn2 && infoBtn) {
        joinBtn.addEventListener('click', () => goLink('join'));
        contentsBtn1.addEventListener('click', () => goLink('contents', 189137));
        contentsBtn2.addEventListener('click', () => goLink('contents', 189139));
        infoBtn.addEventListener('click', () => goLink('info'));
    }
};
initialize();
